import { Heading } from "@chakra-ui/react";
import { Routes, Route } from "react-router-dom";
import { useChangeNetworkStatus } from "../../hooks/useChangeNetworkStatus";
import {
  CargaItemAgrupamentoList,
  CargaItemList,
  CargaList,
  CargaListFinalizadas,
  DocumentosMotorista,
  InformeRendimentoMotorista,
} from "../carga/views";
import {
  OpcoesEntrega,
  OpcoesEntregaGrupo,
  RegistrarClienteAusente,
  RegistrarDevolucao,
  RegistrarDevolucaoGrupo,
  RegistrarEntrega,
  RegistrarEntregaGrupo,
} from "../entrega/views";
import { Login } from "../login/login";
import { NotFound } from "../sistema/views";
import { TransbordoEdit, TransbordoList } from "../transbordo/views";
import useIsMobile from "../../hooks/useIsMobile";
import { ImagensRejeitadas } from "../imagens-rejeitadas/views/ImagensRejeitadas";
import { AgrupamentoItemList } from "../agrupamento/views";

export const Router: React.FC<{}> = () => {
  useChangeNetworkStatus();
  useIsMobile();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<CargaList />} />
      <Route path="/cargas" element={<CargaList />} />
      <Route path="/cargas-finalizadas" element={<CargaListFinalizadas />} />
      <Route path="/agrupamentos/:ukey" element={<AgrupamentoItemList />} />
      <Route path="/cargas/:ukey" element={<CargaItemList />} />
      <Route path="/cargas/:ukey/agrupamento/:codigo_agrupamento" element={<CargaItemAgrupamentoList />} />
      <Route path="/entrega/:tipo/:ukey/opcoes" element={<OpcoesEntrega />} /> {/* tipo = transbordo */}
      <Route path="/entrega/:tipo/:ukey/opcoes/cliente-ausente" element={<RegistrarClienteAusente />} /> {/* tipo = transbordo */}
      <Route path="/entrega/:tipo/:ukey/opcoes/devolucao" element={<RegistrarDevolucao />} /> {/* tipo = transbordo */}
      <Route path="/entrega/:tipo/:ukey/opcoes/entregar" element={<RegistrarEntrega />} /> {/* tipo = transbordo */}
      <Route path="/entrega/:tipo/:ukey/:j10_ukey/opcoes" element={<OpcoesEntrega />} /> {/* tipo = nota */}
      <Route path="/entrega/:tipo/:ukey/:j10_ukey/opcoes/cliente-ausente" element={<RegistrarClienteAusente />} /> {/* tipo = nota */}
      <Route path="/entrega/:tipo/:ukey/:j10_ukey/opcoes/devolucao" element={<RegistrarDevolucao />} /> {/* tipo = nota */}
      <Route path="/entrega/:tipo/:ukey/:j10_ukey/opcoes/entregar" element={<RegistrarEntrega />} /> {/* tipo = nota */}
      <Route path="/entrega/grupo/:ukey/:j10_ukey/opcoes" element={<OpcoesEntregaGrupo />} /> {/* entrega agrupada por cliente (REACT_APP_LISTAR_POR_ENTREGA) */}
      <Route path="/entrega/grupo/:ukey/:j10_ukey/opcoes/devolucao" element={<RegistrarDevolucaoGrupo />} />
      <Route path="/entrega/grupo/:ukey/:j10_ukey/opcoes/entregar" element={<RegistrarEntregaGrupo />} />
      <Route path="/transbordos" element={<TransbordoList />} />
      <Route path="/transbordos/:j14_ukey" element={<TransbordoEdit />} />
      <Route path="/documentos" element={<DocumentosMotorista />} />
      <Route path="/informe-rendimentos" element={<InformeRendimentoMotorista />} />
      <Route path="/imagens-rejeitadas" element={<ImagensRejeitadas />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
